import { ReactourStep } from 'reactour';
import { ImageStepWrapper } from '@components/shared';

interface TourSteps {
  staff: ReactourStep[];
  student: ReactourStep[];
}

const WelcomeStep = () => {
  return (
    <ImageStepWrapper>
      <img className="bot" src="/images/bots/hello-bot.svg" alt="Welcome Bot" />
      Welcome to the Institute Management System 🙏 My name is Eli. Let me give you a tour of the basics.
    </ImageStepWrapper>
  );
};

export const tourSteps: TourSteps = {
  staff: [
    {
      selector: '',
      content: <WelcomeStep />,
    },
    {
      selector: '#app-top-menu',
      content:
        'You can use this top navigation bar to access user related actions such as User Profile, Starting a Tour, User Log Out, etc',
    },
    {
      selector: '#app-sidebar',
      content:
        'This sidebar will be your main navigation area. Everything you are permitted to perform will be listed in here.',
    },
    {
      selector: '#dashboard-quick-links',
      content: 'These quick links will be able to take you to some frequently used sections in the system fast.',
    },
    {
      selector: '#help-tour',
      content: 'Whenever a page have a tour available, you will see my face in the bottom right corner like this.',
    },
    {
      selector: '',
      content: "Now head on to a different section using the Sidebar and I'll be there to guide you! 👋",
    },
  ],
  student: [
    {
      selector: '',
      content: <WelcomeStep />,
    },
    {
      selector: '#app-top-menu',
      content:
        'You can use this top navigation bar to access user related actions such as User Profile, Starting a Tour, User Log Out, etc',
    },
    {
      selector: '#app-sidebar',
      content:
        'This sidebar will be your main navigation area. Everything you are permitted to perform will be listed in here.',
    },
    {
      selector: '#dashboard-quick-links',
      content: 'These quick links will be able to take you to some frequently used sections in the system fast.',
    },
    {
      selector: '#help-tour',
      content: 'Whenever a page have a tour available, you will see my face in the bottom right corner like this.',
    },
    {
      selector: '',
      content: "Now head on to a different section using the Sidebar and I'll be there to guide you! 👋",
    },
  ],
};
